import { Button, Divider, Drawer, List, Space, Typography } from "antd"
import DrawerInput from "./DrawerInput"
import { useIntl } from "react-intl"
import { useMemo, useState } from "react"
import Image from "next/image"
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil"
import { ISeatingPreference } from "../../../Orchestrator/Types/Interface/ISeatingPreference"

interface IProps {
  title?: string
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
}

export const DEFAULT_SEATING_TYPE = "SIDE_BY_SIDE"

const SeatingInput = (props: IProps) => {
  const intl = useIntl()
  const { title = intl.formatMessage({ id: "seatingText" }), value = "noPreference", onChange, placeholder } = props
  const [open, setOpen] = useState(false)

  const [seatingOptions] = useRecState<ISeatingPreference | null>("seatingPreferencesAtom")

  const onClose = () => setOpen(false)

  const handleClick = (value: string) => {
    onChange?.(value)
    onClose()
  }

  const valuePreview = useMemo(() => {
    const matchingOption = seatingOptions?.position?.find((option) => option.value === value)

    if (!matchingOption) return "";

    return matchingOption.label || (placeholder || intl.formatMessage({ id: "noPreferencePlaceholder" }))
  }, [value, seatingOptions, intl, placeholder])

  return (
    <div className="w-100">
      <DrawerInput
        title={title}
        value={valuePreview}
        onClick={() => setOpen(true)}
        placeholder={placeholder || intl.formatMessage({ id: "noPreferencePlaceholder" })}
      />

      <Drawer
        title={
          <span className="fs-20 fw-600">
            {title}
          </span>
        }
        classNames={{
          header: "border-color-00000033",
          body: "p-0"
        }}
        onClose={onClose}
        open={open}
        mask={{ closable: false }}
        closeIcon={null}
        width={"407px"}
        extra={
          <Button
            onClick={onClose}
            variant="text"
            type="text"
            className="center-btn-icon"
            icon={
              <Image
                src="/assets/search_icons/close.svg"
                height={18}
                width={18}
                alt="close"
              />
            }
          />
        }
      >
        <div className="pl-24 pr-16">
          <List
            dataSource={seatingOptions?.position || []}
            bordered={false}
            renderItem={(item) => (
              <List.Item onClick={() => handleClick(item.value)} className="cursor-pointer">
                <Typography.Text className="color-2F3034 fs-16">
                  {item.label}
                </Typography.Text>
              </List.Item>
            )}
          />
          <Divider className="m-0" />
        </div>
      </Drawer>
    </div>
  )
}

export default SeatingInput
